import { api } from './client';

export type UpcomingEventKind = 'birthday' | 'time_off_start' | 'time_off_end' | 'holiday';

export interface UpcomingEvent {
  kind: UpcomingEventKind;
  date: string; // YYYY-MM-DD
  days_until: number;
  employee_id?: number;
  employee_name?: string;
  /** birthday: the age the employee is turning */
  turns?: number;
  /** time_off_*: TimeOffType string */
  time_off_type?: string;
  /** time_off_start: last day of the leave */
  end_date?: string;
  /** holiday */
  holiday_name?: string;
}

export async function listUpcomingEvents(days = 14): Promise<UpcomingEvent[]> {
  const { data } = await api.get<{ data: UpcomingEvent[] }>('/notifications/upcoming', {
    params: { days },
  });
  return data.data;
}
